<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
<h2>{{'CURRENCY.TITLE' | translate}}</h2>
<ntr-add-button [openView]="'currency/add'"></ntr-add-button>

<ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'currency'" [modelView]="'currency'"
               [disableHeader]="false"
               (onQuery)="onGridQuery($event)"
               [columns]="columns"
               [headers]="['','Name','Code']"
               (onDeleteQuery)="deleteCurrency($event)">
</ntr-datatable>
</div>